/**
 * Firebase Web SDK for my.x9.app (account + billing portal).
 * Same project as mobile / use.x9.app.
 */
import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  type Auth,
} from 'firebase/auth';
import { getFunctions, type Functions } from 'firebase/functions';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { initFirebaseAppCheck } from '@x9/web-firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyBJlhU0x9Hbgt8Wc3f-q4jQr03srH4zHR4',
  authDomain: 'x9app-51a91.firebaseapp.com',
  projectId: 'x9app-51a91',
  storageBucket: 'x9app-51a91.firebasestorage.app',
  messagingSenderId: '587102067937',
  appId: '1:587102067937:web:f540b591a842ee291caba0',
  measurementId: 'G-4R2Q9V69HG',
};

let _app: FirebaseApp | null = null;
let _auth: Auth | null = null;
let _functions: Functions | null = null;
let _db: Firestore | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (_app) return _app;
  _app = getApps()[0] ?? initializeApp(firebaseConfig);
  initFirebaseAppCheck(_app);
  return _app;
}

export function getFirebaseAuth(): Auth {
  if (_auth) return _auth;
  const app = getFirebaseApp();
  try {
    _auth = initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });
  } catch {
    _auth = getAuth(app);
  }
  return _auth;
}

export function getFirebaseFunctions(): Functions {
  if (_functions) return _functions;
  _functions = getFunctions(getFirebaseApp(), 'us-central1');
  return _functions;
}

export function getFirebaseDb(): Firestore {
  if (_db) return _db;
  _db = getFirestore(getFirebaseApp());
  return _db;
}
